import { render, staticRenderFns } from "./FormPayment.vue?vue&type=template&id=5bd48b02&scoped=true"
import script from "./FormPayment.vue?vue&type=script&lang=js"
export * from "./FormPayment.vue?vue&type=script&lang=js"
import style0 from "./FormPayment.vue?vue&type=style&index=0&id=5bd48b02&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd48b02",
  null
  
)

export default component.exports